export default function computeClassName(propClassName = '', className = '') {
  return !!className ?
    (
      !!propClassName ?
        `${propClassName} ${className}`.trim() :
        className.trim()
    ) :
    (
      !!propClassName ?
        propClassName.trim():
        ''
    );
}
